import { createAction } from 'redux-act';

export const updateBookingState = createAction('update field(s) in the booking state');
export const clearBookingState = createAction('reset the booking state to initialState');
